import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FileExporterOption } from '../../models';

@Component({
	selector: 'app-file-exporter-choice-popup',
	templateUrl: './file-exporter-choice-popup.component.html',
	styleUrls: ['./file-exporter-choice-popup.component.scss']
})
export class FileExporterChoicePopupComponent {
	public selectedOption: string = FileExporterOption.xlsx;
	public fileExporterOption = FileExporterOption;

	public constructor(private modalController: ModalController) {}

	public close(): void {
		this.modalController.dismiss(FileExporterOption.none);
	}

	public export(): void {
		this.modalController.dismiss(this.selectedOption);
	}

	public onValueChange(event: any): void {
		this.selectedOption = event.detail.value;
	}

	protected chooseOption(option: FileExporterOption) {
		this.selectedOption = option;
	}
}
